import React from "react";
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableContainerProps,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Typography,
  paperClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

// AppTableContainer estilizado com Paper
export const AppTableContainer = styled((props) => (
  <TableContainer component={Paper} elevation={0} {...props} />
))(({ theme }) => ({
  border: `1px solid ${colors.gray100}`,
  overflow: "hidden",
  [`&.${paperClasses.rounded}`]: {
    borderRadius: "8px",
  },
}));

// AppTable baseado no componente original do MUI
export const AppTable = styled(MuiTable)(({ theme }) => ({
  minWidth: 650,
  borderCollapse: "collapse",
}));

// TableHead e Body estendidos
export const AppTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
}));

export const AppTableBody = styled(TableBody)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

// TableRow
export const AppTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td": {
    borderBottom: "none",
  },
}));

// TableCell base
export const AppTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: "8px 16px",
  color: colors.gray600,

  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 400,
  fontStyle: "normal",
  lineHeight: "16px",
  letterSpacing: "0.4px",
}));

// HeaderCell que estende TableCell
export const AppHeaderCell = styled(AppTableCell)(({ theme }) => ({
  color: colors.gray800,
  backgroundColor: colors.gray50,

  fontWeight: 700,
  letterSpacing: "0.5px",
}));
